import React, { useState, useEffect, useRef } from 'react';

const countries = [
    { name: 'Afghanistan', code: 'AF', dial: '+93' },
    { name: 'Albania', code: 'AL', dial: '+355' },
    { name: 'Algeria', code: 'DZ', dial: '+213' },
    { name: 'Andorra', code: 'AD', dial: '+376' },
    { name: 'Angola', code: 'AO', dial: '+244' },
    { name: 'Argentina', code: 'AR', dial: '+54' },
    { name: 'Armenia', code: 'AM', dial: '+374' },
    { name: 'Australia', code: 'AU', dial: '+61' },
    { name: 'Austria', code: 'AT', dial: '+43' },
    { name: 'Azerbaijan', code: 'AZ', dial: '+994' },
    { name: 'Bahamas', code: 'BS', dial: '+1-242' },
    { name: 'Bahrain', code: 'BH', dial: '+973' },
    { name: 'Bangladesh', code: 'BD', dial: '+880' },
    { name: 'Barbados', code: 'BB', dial: '+1-246' },
    { name: 'Belarus', code: 'BY', dial: '+375' },
    { name: 'Belgium', code: 'BE', dial: '+32' },
    { name: 'Belize', code: 'BZ', dial: '+501' },
    { name: 'Benin', code: 'BJ', dial: '+229' },
    { name: 'Bhutan', code: 'BT', dial: '+975' },
    { name: 'Bolivia', code: 'BO', dial: '+591' },
    { name: 'Bosnia and Herzegovina', code: 'BA', dial: '+387' },
    { name: 'Botswana', code: 'BW', dial: '+267' },
    { name: 'Brazil', code: 'BR', dial: '+55' },
    { name: 'Brunei', code: 'BN', dial: '+673' },
    { name: 'Bulgaria', code: 'BG', dial: '+359' },
    { name: 'Burkina Faso', code: 'BF', dial: '+226' },
    { name: 'Burundi', code: 'BI', dial: '+257' },
    { name: 'Cambodia', code: 'KH', dial: '+855' },
    { name: 'Cameroon', code: 'CM', dial: '+237' },
    { name: 'Canada', code: 'CA', dial: '+1' },
    { name: 'Cape Verde', code: 'CV', dial: '+238' },
    { name: 'Central African Republic', code: 'CF', dial: '+236' },
    { name: 'Chad', code: 'TD', dial: '+235' },
    { name: 'Chile', code: 'CL', dial: '+56' },
    { name: 'China', code: 'CN', dial: '+86' },
    { name: 'Colombia', code: 'CO', dial: '+57' },
    { name: 'Comoros', code: 'KM', dial: '+269' },
    { name: 'Congo', code: 'CG', dial: '+242' },
    { name: 'Costa Rica', code: 'CR', dial: '+506' },
    { name: 'Croatia', code: 'HR', dial: '+385' },
    { name: 'Cuba', code: 'CU', dial: '+53' },
    { name: 'Cyprus', code: 'CY', dial: '+357' },
    { name: 'Czech Republic', code: 'CZ', dial: '+420' },
    { name: 'Denmark', code: 'DK', dial: '+45' },
    { name: 'Djibouti', code: 'DJ', dial: '+253' },
    { name: 'Dominica', code: 'DM', dial: '+1-767' },
    { name: 'Dominican Republic', code: 'DO', dial: '+1-809' },
    { name: 'Ecuador', code: 'EC', dial: '+593' },
    { name: 'Egypt', code: 'EG', dial: '+20' },
    { name: 'El Salvador', code: 'SV', dial: '+503' },
    { name: 'Equatorial Guinea', code: 'GQ', dial: '+240' },
    { name: 'Eritrea', code: 'ER', dial: '+291' },
    { name: 'Estonia', code: 'EE', dial: '+372' },
    { name: 'Ethiopia', code: 'ET', dial: '+251' },
    { name: 'Fiji', code: 'FJ', dial: '+679' },
    { name: 'Finland', code: 'FI', dial: '+358' },
    { name: 'France', code: 'FR', dial: '+33' },
    { name: 'Gabon', code: 'GA', dial: '+241' },
    { name: 'Gambia', code: 'GM', dial: '+220' },
    { name: 'Georgia', code: 'GE', dial: '+995' },
    { name: 'Germany', code: 'DE', dial: '+49' },
    { name: 'Ghana', code: 'GH', dial: '+233' },
    { name: 'Greece', code: 'GR', dial: '+30' },
    { name: 'Grenada', code: 'GD', dial: '+1-473' },
    { name: 'Guatemala', code: 'GT', dial: '+502' },
    { name: 'Guinea', code: 'GN', dial: '+224' },
    { name: 'Guinea-Bissau', code: 'GW', dial: '+245' },
    { name: 'Guyana', code: 'GY', dial: '+592' },
    { name: 'Haiti', code: 'HT', dial: '+509' },
    { name: 'Honduras', code: 'HN', dial: '+504' },
    { name: 'Hungary', code: 'HU', dial: '+36' },
    { name: 'Iceland', code: 'IS', dial: '+354' },
    { name: 'India', code: 'IN', dial: '+91' },
    { name: 'Indonesia', code: 'ID', dial: '+62' },
    { name: 'Iran', code: 'IR', dial: '+98' },
    { name: 'Iraq', code: 'IQ', dial: '+964' },
    { name: 'Ireland', code: 'IE', dial: '+353' },
    { name: 'Israel', code: 'IL', dial: '+972' },
    { name: 'Italy', code: 'IT', dial: '+39' },
    { name: 'Ivory Coast', code: 'CI', dial: '+225' },
    { name: 'Jamaica', code: 'JM', dial: '+1-876' },
    { name: 'Japan', code: 'JP', dial: '+81' },
    { name: 'Jordan', code: 'JO', dial: '+962' },
    { name: 'Kazakhstan', code: 'KZ', dial: '+7' },
    { name: 'Kenya', code: 'KE', dial: '+254' },
    { name: 'Kiribati', code: 'KI', dial: '+686' },
    { name: 'Kuwait', code: 'KW', dial: '+965' },
    { name: 'Kyrgyzstan', code: 'KG', dial: '+996' },
    { name: 'Laos', code: 'LA', dial: '+856' },
    { name: 'Latvia', code: 'LV', dial: '+371' },
    { name: 'Lebanon', code: 'LB', dial: '+961' },
    { name: 'Lesotho', code: 'LS', dial: '+266' },
    { name: 'Liberia', code: 'LR', dial: '+231' },
    { name: 'Libya', code: 'LY', dial: '+218' },
    { name: 'Liechtenstein', code: 'LI', dial: '+423' },
    { name: 'Lithuania', code: 'LT', dial: '+370' },
    { name: 'Luxembourg', code: 'LU', dial: '+352' },
    { name: 'Madagascar', code: 'MG', dial: '+261' },
    { name: 'Malawi', code: 'MW', dial: '+265' },
    { name: 'Malaysia', code: 'MY', dial: '+60' },
    { name: 'Maldives', code: 'MV', dial: '+960' },
    { name: 'Mali', code: 'ML', dial: '+223' },
    { name: 'Malta', code: 'MT', dial: '+356' },
    { name: 'Marshall Islands', code: 'MH', dial: '+692' },
    { name: 'Mauritania', code: 'MR', dial: '+222' },
    { name: 'Mauritius', code: 'MU', dial: '+230' },
    { name: 'Mexico', code: 'MX', dial: '+52' },
    { name: 'Micronesia', code: 'FM', dial: '+691' },
    { name: 'Moldova', code: 'MD', dial: '+373' },
    { name: 'Monaco', code: 'MC', dial: '+377' },
    { name: 'Mongolia', code: 'MN', dial: '+976' },
    { name: 'Montenegro', code: 'ME', dial: '+382' },
    { name: 'Morocco', code: 'MA', dial: '+212' },
    { name: 'Mozambique', code: 'MZ', dial: '+258' },
    { name: 'Myanmar', code: 'MM', dial: '+95' },
    { name: 'Namibia', code: 'NA', dial: '+264' },
    { name: 'Nauru', code: 'NR', dial: '+674' },
    { name: 'Nepal', code: 'NP', dial: '+977' },
    { name: 'Netherlands', code: 'NL', dial: '+31' },
    { name: 'New Zealand', code: 'NZ', dial: '+64' },
    { name: 'Nicaragua', code: 'NI', dial: '+505' },
    { name: 'Niger', code: 'NE', dial: '+227' },
    { name: 'Nigeria', code: 'NG', dial: '+234' },
    { name: 'North Korea', code: 'KP', dial: '+850' },
    { name: 'North Macedonia', code: 'MK', dial: '+389' },
    { name: 'Norway', code: 'NO', dial: '+47' },
    { name: 'Oman', code: 'OM', dial: '+968' },
    { name: 'Pakistan', code: 'PK', dial: '+92' },
    { name: 'Palau', code: 'PW', dial: '+680' },
    { name: 'Palestine', code: 'PS', dial: '+970' },
    { name: 'Panama', code: 'PA', dial: '+507' },
    { name: 'Papua New Guinea', code: 'PG', dial: '+675' },
    { name: 'Paraguay', code: 'PY', dial: '+595' },
    { name: 'Peru', code: 'PE', dial: '+51' },
    { name: 'Philippines', code: 'PH', dial: '+63' },
    { name: 'Poland', code: 'PL', dial: '+48' },
    { name: 'Portugal', code: 'PT', dial: '+351' },
    { name: 'Qatar', code: 'QA', dial: '+974' },
    { name: 'Romania', code: 'RO', dial: '+40' },
    { name: 'Russia', code: 'RU', dial: '+7' },
    { name: 'Rwanda', code: 'RW', dial: '+250' },
    { name: 'Saint Kitts and Nevis', code: 'KN', dial: '+1-869' },
    { name: 'Saint Lucia', code: 'LC', dial: '+1-758' },
    { name: 'Saint Vincent', code: 'VC', dial: '+1-784' },
    { name: 'Samoa', code: 'WS', dial: '+685' },
    { name: 'San Marino', code: 'SM', dial: '+378' },
    { name: 'Sao Tome and Principe', code: 'ST', dial: '+239' },
    { name: 'Saudi Arabia', code: 'SA', dial: '+966' },
    { name: 'Senegal', code: 'SN', dial: '+221' },
    { name: 'Serbia', code: 'RS', dial: '+381' },
    { name: 'Seychelles', code: 'SC', dial: '+248' },
    { name: 'Sierra Leone', code: 'SL', dial: '+232' },
    { name: 'Singapore', code: 'SG', dial: '+65' },
    { name: 'Slovakia', code: 'SK', dial: '+421' },
    { name: 'Slovenia', code: 'SI', dial: '+386' },
    { name: 'Solomon Islands', code: 'SB', dial: '+677' },
    { name: 'Somalia', code: 'SO', dial: '+252' },
    { name: 'South Africa', code: 'ZA', dial: '+27' },
    { name: 'South Korea', code: 'KR', dial: '+82' },
    { name: 'South Sudan', code: 'SS', dial: '+211' },
    { name: 'Spain', code: 'ES', dial: '+34' },
    { name: 'Sri Lanka', code: 'LK', dial: '+94' },
    { name: 'Sudan', code: 'SD', dial: '+249' },
    { name: 'Suriname', code: 'SR', dial: '+597' },
    { name: 'Sweden', code: 'SE', dial: '+46' },
    { name: 'Switzerland', code: 'CH', dial: '+41' },
    { name: 'Syria', code: 'SY', dial: '+963' },
    { name: 'Taiwan', code: 'TW', dial: '+886' },
    { name: 'Tajikistan', code: 'TJ', dial: '+992' },
    { name: 'Tanzania', code: 'TZ', dial: '+255' },
    { name: 'Thailand', code: 'TH', dial: '+66' },
    { name: 'Timor-Leste', code: 'TL', dial: '+670' },
    { name: 'Togo', code: 'TG', dial: '+228' },
    { name: 'Tonga', code: 'TO', dial: '+676' },
    { name: 'Trinidad and Tobago', code: 'TT', dial: '+1-868' },
    { name: 'Tunisia', code: 'TN', dial: '+216' },
    { name: 'Turkey', code: 'TR', dial: '+90' },
    { name: 'Turkmenistan', code: 'TM', dial: '+993' },
    { name: 'Tuvalu', code: 'TV', dial: '+688' },
    { name: 'Uganda', code: 'UG', dial: '+256' },
    { name: 'Ukraine', code: 'UA', dial: '+380' },
    { name: 'United Arab Emirates', code: 'AE', dial: '+971' },
    { name: 'United Kingdom', code: 'GB', dial: '+44' },
    { name: 'United States', code: 'US', dial: '+1' },
    { name: 'Uruguay', code: 'UY', dial: '+598' },
    { name: 'Uzbekistan', code: 'UZ', dial: '+998' },
    { name: 'Vanuatu', code: 'VU', dial: '+678' },
    { name: 'Vatican City', code: 'VA', dial: '+379' },
    { name: 'Venezuela', code: 'VE', dial: '+58' },
    { name: 'Vietnam', code: 'VN', dial: '+84' },
    { name: 'Yemen', code: 'YE', dial: '+967' },
    { name: 'Zambia', code: 'ZM', dial: '+260' },
    { name: 'Zimbabwe', code: 'ZW', dial: '+263' },
];

const styles = {
    container: {
        display: 'flex',
        gap: '8px',
        width: '100%',
        alignItems: 'center',
    },
    selectWrapper: {
        position: 'relative',
        width: '160px',
        flexShrink: 0,
    },
    trigger: {
        width: '100%',
        height: '50px',
        padding: '0 12px',
        border: '1px solid #d1d5db',
        borderRadius: '8px',
        fontSize: '16px',
        cursor: 'pointer',
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        transition: 'all 0.2s',
    },
    triggerOpen: {
        borderBottomLeftRadius: '0',
        borderBottomRightRadius: '0',
        borderColor: '#3b82f6',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    },
    dropdown: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        border: '1px solid #d1d5db',
        borderTop: 'none',
        borderRadius: '0 0 8px 8px',
        maxHeight: '320px',
        overflow: 'hidden',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
        zIndex: 1000,
    },
    searchTrigger: {
        padding: '0 12px',
        backgroundColor: '#f9fafb',
    },
    optionsList: {
        maxHeight: '270px',
        overflowY: 'auto',
    },
    option: {
        padding: '12px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        transition: 'background-color 0.15s',
    },
    optionHover: {
        backgroundColor: '#f3f4f6',
    },
    flag: {
        width: '28px',
        height: '21px',
        borderRadius: '4px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        objectFit: 'cover',
    },
    textInfo: {
        flex: 1,
        minWidth: 0,
    },
    countryName: {
        fontWeight: '500',
        color: '#111',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    dialCode: {
        color: '#6b7280',
        fontSize: '14px',
    },
    inputWrapper: {
        flex: 1,
    },
    input: {
        width: '100%',
        height: '50px',
        padding: '0 16px',
        border: '1px solid #d1d5db',
        borderRadius: '8px',
        fontSize: '16px',
        boxSizing: 'border-box',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        transition: 'all 0.2s',
    },
    inputFocus: {
        borderColor: '#3b82f6',
        boxShadow: '0 0 0 3px rgba(59,130,246,0.2)',
    },
};

export default function PhoneInput({
    value,
    onChange,
    required = false,
    name = 'phone',
    placeholder = '800 000 0000',
    containerStyle = {},
    selectStyle = {},
    inputStyle = {},
    selectWrapperStyle = {},
    inputWrapperStyle = {}
}) {
    const parsePhoneValue = (phoneValue) => {
        const phoneStr = String(phoneValue || '').trim();

        if (!phoneStr) {
            const nigeriaIndex = countries.findIndex(c => c.code === 'NG');
            return { countryIndex: nigeriaIndex !== -1 ? nigeriaIndex : 0, number: '' };
        }

        const cleanPhoneStr = phoneStr.replace(/\s+/g, '');
        const sortedCountries = [...countries].sort((a, b) => b.dial.length - a.dial.length);

        const matchedCountry = sortedCountries.find(c => {
            const cleanDial = c.dial.replace(/\s+/g, '');
            return cleanPhoneStr.startsWith(cleanDial);
        });

        if (matchedCountry) {
            const countryIndex = countries.findIndex(c => c.code === matchedCountry.code);
            const cleanDial = matchedCountry.dial.replace(/\s+/g, '');
            const number = cleanPhoneStr.slice(cleanDial.length);
            return { countryIndex, number };
        }

        const nigeriaIndex = countries.findIndex(c => c.code === 'NG');
        return { countryIndex: nigeriaIndex !== -1 ? nigeriaIndex : 0, number: cleanPhoneStr };
    };

    const { countryIndex: initialCountryIndex, number: initialNumber } = parsePhoneValue(value);
    const [selectedCountry, setSelectedCountry] = useState(initialCountryIndex);
    const [phoneNumber, setPhoneNumber] = useState(initialNumber);
    const [isOpen, setIsOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const wrapperRef = useRef(null);
    const searchInputRef = useRef(null);

    useEffect(() => {
        const parsed = parsePhoneValue(value);
        setSelectedCountry(parsed.countryIndex);
        setPhoneNumber(parsed.number);
    }, [value]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchQuery('');
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (isOpen && searchInputRef.current) {
            searchInputRef.current.focus();
            searchInputRef.current.select();
        }
    }, [isOpen]);

    const handleToggle = () => {
        if (!isOpen) {
            setIsOpen(true);
            setSearchQuery('');
        }
    };

    const handleCountrySelect = (index) => {
        setSelectedCountry(index);
        setIsOpen(false);
        setSearchQuery('');
        const fullNumber = phoneNumber ? `${countries[index].dial}${phoneNumber}` : '';
        onChange(fullNumber);
    };

    const handleNumberChange = (e) => {
        const newNumber = e.target.value.replace(/\D/g, '');
        setPhoneNumber(newNumber);
        const fullNumber = newNumber ? `${countries[selectedCountry].dial}${newNumber}` : '';
        onChange(fullNumber);
    };

    const getFlagUrl = (code) => `https://flagcdn.com/48x36/${code.toLowerCase()}.png`;

    const filteredCountries = countries.filter(country =>
        searchQuery === '' ||
        country.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        country.code.toLowerCase().includes(searchQuery.toLowerCase()) ||
        country.dial.includes(searchQuery)
    );

    const selectedCountryData = countries[selectedCountry];

    return (
        <div style={{ ...styles.container, ...containerStyle }}>
            <div ref={wrapperRef} style={{ ...styles.selectWrapper, ...selectWrapperStyle }}>
                {/* Closed state - shows selected country */}
                {!isOpen && (
                    <div
                        style={{ ...styles.trigger, ...selectStyle }}
                        onClick={handleToggle}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleToggle()}
                    >
                        <img
                            src={getFlagUrl(selectedCountryData.code)}
                            alt=""
                            style={styles.flag}
                        />
                        <span style={{ fontWeight: '500' }}>{selectedCountryData.dial}</span>
                        <svg style={{ marginLeft: 'auto', width: '16px', height: '16px', color: '#6b7280' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                )}

                {/* Open state - search directly in the trigger area */}
                {isOpen && (
                    <>
                        <div
                            style={{
                                ...styles.trigger,
                                ...styles.triggerOpen,
                                ...styles.searchTrigger,
                            }}
                        >
                            <input
                                ref={searchInputRef}
                                type="text"
                                placeholder="Search countries..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{
                                    flex: 1,
                                    border: 'none',
                                    outline: 'none',
                                    background: 'transparent',
                                    fontSize: '16px',
                                    color: '#111',
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Escape') {
                                        setIsOpen(false);
                                        setSearchQuery('');
                                    }
                                }}
                            />
                            <svg style={{ width: '18px', height: '18px', color: '#9ca3af' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </div>

                        <div style={styles.dropdown}>
                            <div style={styles.optionsList}>
                                {filteredCountries.length === 0 ? (
                                    <div style={{ padding: '16px', textAlign: 'center', color: '#9ca3af' }}>
                                        No countries found
                                    </div>
                                ) : (
                                    filteredCountries.map((country, idx) => (
                                        <div
                                            key={country.code}
                                            style={{
                                                ...styles.option,
                                                ...(hoveredIndex === idx ? styles.optionHover : {}),
                                            }}
                                            onClick={() => handleCountrySelect(countries.indexOf(country))}
                                            onMouseEnter={() => setHoveredIndex(idx)}
                                        >
                                            <img
                                                src={getFlagUrl(country.code)}
                                                alt=""
                                                style={styles.flag}
                                            />
                                            <div style={styles.textInfo}>
                                                <div style={styles.countryName}>{country.name}</div>
                                                <div style={styles.dialCode}>{country.dial} ({country.code})</div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>

            <div style={{ ...styles.inputWrapper, ...inputWrapperStyle }}>
                <input
                    type="tel"
                    value={phoneNumber}
                    onChange={handleNumberChange}
                    style={{ ...styles.input, ...inputStyle }}
                    placeholder={placeholder}
                    required={required}
                    inputMode="numeric"
                />
            </div>
        </div>
    );
}